export default function defaultLayout({children}) {

return <div className="default-wrapper">
    {children}
    </div>;
}

